// price：''（需通过接口获取价格）
export const menberList = [
  {
    name: '迷你CAD会员',
    class: 'minivip',
    price: '',
    type: 'vip',
    vip: false,
    text: '立即开通',
    desList: ['转换工具', '文字处理', '云服务', '常用工具', '账号互通']
  },
  {
    name: '图库增值包',
    class: 'galleryvip',
    price: '48',
    type: 'galleryvip',
    vip: false,
    text: '立即开通',
    desList: ['海康威视弱电图例', '商用厨房', '停车场', '室内装饰装修', '化工类', '超多精品图库']
  },
  {
    name: '超级会员',
    class: 'supervip',
    price: '',
    type: 'svip',
    vip: false,
    text: '立即开通',
    des: '（迷你CAD会员+图库增值包）',
    desList: ['转换工具', '文字处理', '云服务', '常用工具', '账号互通']
  },
  {
    name: '三维CAD看图会员',
    class: 'threevip',
    price: '128',
    type: 'mini3d',
    vip: false,
    text: '立即开通',
    desList: ['转换工具', '文字处理', '云服务', '常用工具', '账号互通']
  }
]

export const contrastFree = {
  name: '注册用户',
  class: 'free',
  price: '0',
  text: '免费使用',
  type: 'free',
  vip: false
}

export const platform = [
  { label: 'Windows', icon: 'Windows' },
  { label: 'iOS', icon: 'iOS' },
  { label: 'Android', icon: 'Android' },
  { label: 'mac os', icon: 'iOS' }
]

export const info = [
  { label: '企业采购', icon: 'bbuy', link: 'https://app.olcad.com/company/paynew' },
  { label: '私有云SDK', icon: 'sdk', link: 'https://olcad.com/privatecloudsdk.html' }
]

export const contrastList1 = [
  {
    title: '图库',
    list: [
      {
        name: '精品图库<br>-图库会员专属',
        register: false,
        galleryvip: true,
        minivip: false,
        supervip: true,
        threevip: false
      }
    ]
  },
  {
    title: '转换工具',
    list: [
      {
        name: 'PDF转CAD',
        register: false,
        galleryvip: false,
        minivip: true,
        supervip: true,
        threevip: false
      },
      {
        name: 'DWG批量转PDF',
        register: false,
        galleryvip: false,
        minivip: true,
        supervip: true,
        threevip: false
      },
      {
        name: 'DWG批量转DXF',
        register: false,
        galleryvip: false,
        minivip: true,
        supervip: true,
        threevip: false
      },
      {
        name: 'DXF转DWG',
        register: false,
        galleryvip: false,
        minivip: true,
        supervip: true,
        threevip: false
      },
      {
        name: '识别图框转PDF',
        register: false,
        galleryvip: false,
        minivip: true,
        supervip: true,
        threevip: false
      },
      {
        name: '识别图框打印',
        register: false,
        galleryvip: false,
        minivip: true,
        supervip: true,
        threevip: false
      }
    ]
  }
]

export const contrastList2 = [
  {
    title: '文字工具',
    list: [
      {
        name: '查找文字',
        register: false,
        galleryvip: false,
        minivip: true,
        supervip: true,
        threevip: false
      },
      {
        name: '替换文字',
        register: false,
        galleryvip: false,
        minivip: true,
        supervip: true,
        threevip: false
      },
      {
        name: '提取文字',
        register: false,
        galleryvip: false,
        minivip: true,
        supervip: true,
        threevip: false
      },
      {
        name: '提取表格文字',
        register: false,
        galleryvip: false,
        minivip: true,
        supervip: true,
        threevip: false
      }
    ]
  },
  {
    title: '云服务',
    list: [
      {
        name: '云盘扩容',
        register: false,
        galleryvip: false,
        minivip: true,
        supervip: true,
        threevip: true
      },
      {
        name: '大文件上传',
        register: false,
        galleryvip: false,
        minivip: true,
        supervip: true,
        threevip: false
      },
      {
        name: '文件传输助手',
        register: false,
        galleryvip: false,
        minivip: true,
        supervip: true,
        threevip: false
      }
    ]
  },
  {
    title: '常用工具',
    list: [
      {
        name: '离线登录',
        register: false,
        galleryvip: false,
        minivip: true,
        supervip: true,
        threevip: false
      },
      {
        name: '插入图框',
        register: false,
        galleryvip: false,
        minivip: true,
        supervip: true,
        threevip: false
      },
      {
        name: '图纸对比',
        register: false,
        galleryvip: false,
        minivip: true,
        supervip: true,
        threevip: false
      },
      {
        name: '图形统计',
        register: false,
        galleryvip: false,
        minivip: true,
        supervip: true,
        threevip: false
      },
      {
        name: '建筑标注样式',
        register: false,
        galleryvip: false,
        minivip: true,
        supervip: true,
        threevip: false
      }
    ]
  }
]

export const contrastList3 = [
  {
    title: '其他',
    list: [
      {
        name: '账号互通',
        register: ['CAD迷你看图、CAD迷你画图', 'CAD迷你家装'],
        galleryvip: ['CAD迷你看图、CAD迷你画图', 'CAD迷你家装'],
        minivip: ['CAD迷你看图、CAD迷你画图', 'CAD迷你家装'],
        supervip: ['CAD迷你看图、CAD迷你画图', 'CAD迷你家装'],
        threevip: ['三维CAD看图']
      },
      {
        name: '查看三维图纸',
        register: ['仅支持DWG格式'],
        galleryvip: ['仅支持DWG格式'],
        minivip: ['仅支持DWG格式'],
        supervip: ['仅支持DWG格式'],
        threevip: [
          '支持查看CATIA、ProE/',
          'CreoParametric3D、',
          'SOLIDWORKS3D、UGNX3D、',
          'Solidedge 五种主流格式'
        ]
      }
    ]
  }
]

export const questions = [
  {
    text: '已经付费了，仍然提示开通会员，怎么办？',
    url: '010302'
  },
  {
    text: '购买会员后如何开具发票？',
    url: '010401'
  },
  {
    text: '批量购买会员、激活会员',
    url: '010303'
  },
  {
    text: '购买了CAD迷你看图会员，想用CAD迷你画图，是否又要购买？',
    url: '010304'
  },
  {
    text: '会员时长是如何计算的？',
    url: '010305'
  }
]

// price: ''（需接口获取）； price_id、des： ''（需接口获取）；show：是否显示改选项(true:显示)
export const payType = {
  minivip: {
    title: '迷你CAD会员',
    sub_title: '开通会员立享权益',
    tab: [
      { type: 'minivip', name: '迷你CAD会员' },
      { type: 'galleryvip', name: '图库增值包' },
      { type: 'supervip', name: '超级会员', des: '（迷你CAD会员+图库增值包）' }
    ],
    des: [
      '国产研发，解决CAD正版化',
      '快速看图轻松画图',
      'Windows端和手机端账号互通',
      '超多效率工具'
    ],
    thali: [
      { id: 1, time: '1年', price: '', price_id: '', des: '', show: true },
      { id: 2, time: '6个月', price: '', price_id: '', des: '', show: true },
      { id: 3, time: '1个月', price: '', price_id: '', des: '', show: false },
      { id: 4, time: '永久', price: '', price_id: '', des: '', show: false },
    ]
  },
  galleryvip: {
    title: '图库增值包',
    sub_title: '超多精品图库任你使用',
    tab: [
      { type: 'minivip', name: '迷你CAD会员' },
      { type: 'galleryvip', name: '图库增值包' },
      { type: 'supervip', name: '超级会员', des: '（迷你CAD会员+图库增值包）' }
    ],
    des: ['海康威视弱电图例', '商用厨房', '停车场', '室内装饰装修', '化工类', '超多精品图库'],
    thali: [{ time: '1年', price: 48, price_id: 'cyear', des: '全年最低价', show: true }]
  },
  supervip: {
    title: '超级会员',
    sub_title: '迷你CAD会员+图库增值包',
    tab: [
      { type: 'minivip', name: '迷你CAD会员' },
      { type: 'galleryvip', name: '图库增值包' },
      { type: 'supervip', name: '超级会员', des: '（迷你CAD会员+图库增值包）' }
    ],
    des: [
      '国产研发，解决CAD正版化',
      '快速看图轻松画图',
      'Windows端和手机端账号互通',
      '所有精品图库都可使用'
    ],
    thali: [
      { id: 1, time: '1年', price: '', price_id: '', des: '', show: true },
      { id: 2, time: '6个月', price: '', price_id: '', des: '', show: true }
    ]
  },
  threevip: {
    title: '三维CAD看图会员',
    sub_title: '开通会员立享权益',
    tab: [{ type: 'threevip', name: '三维CAD看图会员' }],
    des: [
      '5种主流商业三维CAD格式',
      '支持微信分享',
      '完全中文，提高企业效率',
      '1GB超大云盘，在线分享',
      '超快超小的安装包，分发简单',
      '一年仅100多的优惠VIP会员'
    ],
    thali: [
      { time: '1年', price: 128, price_id: 45, des: '全年最低价', show: true },
      { time: '6个月', price: 78, price_id: 44, des: '全年最低价', show: true }
    ]
  }
}
